import { jsx as _jsx } from "react/jsx-runtime";
import { EditContactIdentityModal } from '../EditContactIdentityModal/EditContactIdentityModal';
import { useContactRowModal } from './useContactRowModal';
export const useEditContactIdentityModal = (testId)=>useContactRowModal('edit_contact_identity_modal', (contact, dismissModal)=>/*#__PURE__*/ _jsx(EditContactIdentityModal, {
            contact: contact,
            dismissModal: dismissModal,
            testId: testId
        }));
